import { gql } from '@apollo/client'

export default gql(`
    mutation adminUpdateSubscription( $id: ID! $email: String! $update: SubscriptionUpdate) {
        adminUpdateSubscription(
            email: $email
            id: $id
            update: $update
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
